<template>
    <div id="app" class="app-shell">
        <modal :showDialog="activeModal == 'EDITPROFILE'"  @close="() => activeModal = 'NONE'" :title="$t('EditProfile')">
            <edit-profile @cancel="activeModal = 'NONE'" @save="activeModal = 'NONE'" style="width: 25vw; overflow-y: scroll;"/>
        </modal>
        <header class="top-logo-bar app-header">
            <div class="app-header__start">
                <button
                    type="button"
                    class="app-header__icon-button"
                    aria-label="Menu"
                    :aria-expanded="String(menuVisible)"
                    @click="menuVisible = !menuVisible"
                >
                    <svg viewBox="0 0 24 24" aria-hidden="true"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 3v18"/></svg>
                </button>
                <span class="app-header__separator"></span>
                <router-link :to="{name: 'systems'}" class="app-header__logo">
                    <img class="app-logo" src="~@/assets/img/Menu/Logo.svg" alt="CRFI Monitoring"/>
                </router-link>
                <template v-if="isSystem && !$store.getters.isMobile && $route.params.systemName">
                    <span class="app-header__separator"></span>
                    <span class="app-header__context">{{ $route.params.systemName }}</span>
                </template>
            </div>
            <user-menu @edit-profile="editProfile"/>
        </header>
        <div class="horizontal grow" style="max-width: 100vw; overflow: hidden;">
            <div>
                <NavigationMenu :absolute="menuAbsolute" :isVisible="menuVisible"/>
            </div>
            <div class="main-router-view" id="main-router-view">
                <div class="mySpinner" v-if="$store.getters.isLoading">
                    <Spinner style="width: 100%; position: fixed; top: 50vh;"></Spinner>
                </div>
                <router-view class="scrollbar style-2" style="height: calc(100vh - 50px)"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import EditProfile from '@/components/Main/EditProfile.vue'
import Modal from '@/components/Modal.vue'
import IconButton from '@/components/IconButton'
import Spinner from 'vue-simple-spinner'
import NavigationMenu from '../components/Main/Menu/NavigationMenu.vue'
import UserMenu from '@/components/Main/UserMenu.vue'

export default {
    components: {
      Modal,
      EditProfile,
      IconButton,
      Spinner,
      NavigationMenu,
      UserMenu
    },
    computed: {
        isSystem() {
            return this.$store.getters.systemId != null || this.$route.fullPath.includes('systemState')
        }
    },
    async mounted() {
        this.$root.$i18n.locale = this.$store.getters.language

        this.$router.beforeEach((to, from, next) => {
            if(this.$store.getters.isMobile) {
                this.menuVisible = false;
            }
            next()
        })

        this.$nextTick(_ => {
            this.menuVisible = !this.$store.getters.isMobile
        })
    },
    data() {
        return {
            activeModal: 'NONE',
            navigationMenu: [
                {
                    href: {name: 'systems'},
                    title: 'Systems',
                    icon: 'fa fa-user',
                    child: [
                        {
                            href: { name: 'map' },
                            title: 'Map'
                        },
                        {
                            href: { name: 'dashboard' },
                            title: 'Dashboard'
                        }
                    ]
                },
                {
                    href: { name: 'alarms' },
                    title: 'Alarms'
                },
                {
                    href: { name: 'visits' },
                    title: 'Service'
                },
                {
                    href: { name: 'users' },
                    title: 'Users',
                    child: [
                        {
                            href: { name: 'users' },
                            title: 'List'
                        },
                        {
                            href: {name: 'invitations'},
                            title: 'Invitations'
                        }
                    ]
                }
            ],
            menuVisible: false,
            menuAbsolute: false
        }
    },
    methods: {
        editProfile() {
            this.activeModal = 'EDITPROFILE'
        }
  }
}
</script>

<style>
    .profile-modal {
        left: 50vw !important;
        top: 50vh !important;
    }
</style>

<style scoped>
span, p, h1, h2, h3, h4, h5 {
        color: #414F51;
    }

    .box {
        height: 850px;
    }

    .nav-bg {
        background-image: linear-gradient(rgb(50, 147, 160), rgb(53, 107, 136));
    }

    main {
        background-image: linear-gradient(to right, rgb(225, 239, 242), rgb(230, 245, 248));
    }

    img {
        vertical-align: middle;
        display: inline-block;
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .darkColor {
        color: rgb(65, 79, 81);
    }

    #menuCell {
        background: rgb(50, 147, 160);
    }

    .list-group {
        overflow-y: auto;
    }

    .list-group-item {
        background: transparent;
        border: 3px solid transparent;
        padding: 4px;
        width: 220px;
        align-items: flex-start;
        align-content: flex-start;
    }

    @media (max-width: 670px) {
        .navbar-mobile {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            z-index: 100;
            padding-top: 92px;
        }

        .blur-mobile {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 99;
            background-color: rgba(50,147,160, 0.6);
        }
    }

    .list-group-item:hover, #menuCellHelper:hover {
        border-left: 3px solid white;
        border-right: 3px solid white;
    }

    .list-group-item:first-child {
        border-radius: 0;
    }

    .helper {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    /*
     * Pasek górny w kolorystyce service-ui: gradient i kolory z tokenów
     * --header-* (assets/css/theme.css), osobne dla trybu jasnego i ciemnego.
     * Wysokość zostaje 50px — od niej liczone są wysokości widoków (100vh - 50px).
     */
    .app-header {
        position: relative;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 0 10px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.14);
        color: var(--header-fg);
    }

    .app-header__start {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
        height: 100%;
    }

    .app-header__icon-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 34px;
        height: 34px;
        padding: 0;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: var(--header-fg);
        cursor: pointer;
        transition: background-color 0.15s ease;
    }

    .app-header__icon-button:hover {
        background-color: var(--header-hover);
    }

    .app-header__icon-button svg {
        width: 20px;
        height: 20px;
        fill: none;
        stroke: currentColor;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .app-header__separator {
        flex-shrink: 0;
        width: 1px;
        height: 24px;
        background-color: var(--header-border);
    }

    .app-header__logo {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .app-header__logo img {
        display: block;
        height: 32px;
    }

    .app-header__context {
        overflow: hidden;
        color: var(--header-fg);
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .selectedSystemsBackground {
      background-color: rgba(0, 125, 149, 1);
    }

    .main-router-view {
        background-color: var(--app-bg);
        width: 100%;
        overflow-x: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue